import React from 'react';
import { Box, Text } from '@mantine/core';

const VendorBidsTab = ({ selectedLineId }) => {
  return (
    <Box p="md">
      <Text>Vendor Bids tab content for Line {selectedLineId} - to be implemented</Text>
    </Box>
  );
};

export default VendorBidsTab;